import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {NodeService} from '../../../services/node.service';
import {Store, select, Action} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {updateInfoType} from '../../../shareModel';

@Injectable()
export class NodeEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private nodeService = inject(NodeService);

  constructor() {}

  readAllNode$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.NodeActionTypes.GetNodes),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      return this.nodeService.ReadAllNode(user.otp).pipe(
        map((res: any) => {
          if (res.result) {
            return new featureActions.LoadNodes({nodes: res.msg.body});
          }
        })
      );
    })
  ));
  updateNode$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.NodeActionTypes.UpdateNodes),
    map((action: featureActions.UpdateNodes) => action.payload.nodes),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        node: payload
      };
      return this.nodeService.UpdateNode(params).pipe(
        map((res: UpdateInfoModel) => {
          const updateRes: UpdateInfoModel = { ...res, type: updateInfoType.EditNode };
          if (res.result) {
            return new featureActions.UpdateInfoSuccessAction(updateRes);
          } else {
            return new featureActions.UpdateInfoFailAction(updateRes);
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.EditNode
          };
          return of(new featureActions.UpdateInfoFailAction(res));
        })
      );
    })
  ));
}
